import { Grid2, Stack, Typography } from '@mui/material';

import { colors } from 'src/global/styles/colors';

import OTCNodesChart from './OTCNodesChart';
import OTCRevenueChart from './OTCRevenueChart';

const OTCSalesSection = () => {
  return (
    <Stack spacing={3}>
      {/* Section Header */}
      <Typography
        sx={{
          color: colors.white,
          fontSize: '24px',
          fontWeight: 700,
          lineHeight: '28px',
        }}>
        OTC Sales
      </Typography>

      <Grid2 container spacing={3}>
        <Grid2 size={{ xs: 12, lg: 6 }}>
          <OTCNodesChart />
        </Grid2>
        <Grid2 size={{ xs: 12, lg: 6 }}>
          <OTCRevenueChart />
        </Grid2>
      </Grid2>
    </Stack>
  );
};

export default OTCSalesSection;
